import {
  string as yupString,
} from 'yup';

import InputFormik from '../../shared/forms/input/inputFormik.component';
import SelectFormik from '../../shared/forms/select/sdkSelectFormik.component';
import {
  required,
  yesNoFlag,
  yesNoAlwaysFlag,
  uniqueWith,
} from '../../shared/forms/validators';
import { yesNoAlwaysFlagOptions, yesNoFlagOptions } from './constants';
import {
  typeDescriptionGetter,
  activityDescriptionGetter,
  slAccountGetter,
} from './valueGetters';

const schema = [
  {
    name: 'type',
    component: SelectFormik,
    meta: { label: 'Type', optionsKey: 'typeOptions' },
    options: { disabledWhenEditing: true, yupType: yupString(), validationRules: [required, uniqueWith(['activity'], 'Combination of Type and Activity already exists')] },
    additionalProps: { required: true },
  },
  {
    name: 'typeDesc',
    component: InputFormik,
    meta: { label: 'Type Description', valueGetter: typeDescriptionGetter },
    options: { yupType: yupString(), readOnly: true },
    additionalProps: { disabled: true },
  },
  {
    name: 'activity',
    component: SelectFormik,
    meta: { label: 'Activity', optionsKey: 'activityOptions' },
    options: { disabledWhenEditing: true, yupType: yupString(), validationRules: [required, uniqueWith(['type'], 'Combination of Type and Activity already exists')] },
    additionalProps: { required: true },
  },
  {
    name: 'activityDesc',
    component: InputFormik,
    meta: { label: 'Activity Description', valueGetter: activityDescriptionGetter },
    options: { yupType: yupString(), readOnly: true },
    additionalProps: { disabled: true },
  },
  {
    name: 'slAccount',
    component: InputFormik,
    meta: { label: 'SL Account', valueGetter: slAccountGetter },
    options: { yupType: yupString(), readOnly: true },
    additionalProps: { disabled: true },
  },
  {
    name: 'allowTopside',
    component: SelectFormik,
    meta: { label: 'Allow Topside', options: yesNoAlwaysFlagOptions },
    options: { yupType: yupString(), validationRules: [yesNoAlwaysFlag, required] },
    additionalProps: { required: true },
  },
  {
    name: 'slView',
    component: SelectFormik,
    meta: { label: 'SL View', optionsKey: 'slViewOptions' },
    options: { yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true },
  },
  {
    name: 'allowEntry',
    component: SelectFormik,
    meta: { label: 'Allow Entry', options: yesNoFlagOptions },
    options: { yupType: yupString(), validationRules: [yesNoFlag, required] },
    additionalProps: { required: true },
  },
  {
    name: 'allowTransfer',
    component: SelectFormik,
    meta: { label: 'Allow Transfer', options: yesNoFlagOptions },
    options: { yupType: yupString(), validationRules: [yesNoFlag, required] },
    additionalProps: { required: true },
  },
];

export default schema;
